import { render, staticRenderFns } from "./Banks.vue?vue&type=template&id=1d47b4dc&scoped=true&"
import script from "./Banks.vue?vue&type=script&lang=js&"
export * from "./Banks.vue?vue&type=script&lang=js&"
import style0 from "./Banks.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Banks.vue?vue&type=style&index=1&id=1d47b4dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d47b4dc",
  null
  
)

export default component.exports